export default function PayRent() {
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              Pay Rent / Add Funds
            </div>
            <div className="page-sub" id="page-sub">
              Submit payment request to your property owner
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          {/* TENANT WALLET MINI */}
          <div
            style={{
              background: "linear-gradient(135deg,#633806,#BA7517)",
              borderRadius: "var(--radius-lg)",
              padding: "22px 28px",
              marginBottom: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 12,
            }}
          >
            <div>
              <div
                style={{
                  fontSize: 11,
                  color: "rgba(255,255,255,0.7)",
                  textTransform: "uppercase",
                  letterSpacing: ".07em",
                  marginBottom: 4,
                }}
              >
                🪙 My Coin Balance
              </div>
              <div style={{ fontSize: 36, fontWeight: 800, color: "#fff" }}>
                850
              </div>
              <div
                style={{
                  fontSize: 11,
                  color: "rgba(255,255,255,0.65)",
                  marginTop: 3,
                }}
              >
                Priya Sharma · Room 204
              </div>
            </div>
            <div style={{ textAlign: "right" }}>
              <button
                onclick="openAddCoinModal('tenant')"
                style={{
                  background: "#fff",
                  color: "#633806",
                  border: "none",
                  borderRadius: "var(--radius-md)",
                  padding: "10px 22px",
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: "pointer",
                  fontFamily: "inherit",
                }}
              >
                + Add Coins
              </button>
            </div>
          </div>
          <div className="two-col">
            <div className="card">
              <div className="card-title">Make Payment</div>
              <div
                style={{
                  background: "var(--blue-light)",
                  borderRadius: "var(--radius-md)",
                  padding: "14px 16px",
                  marginBottom: 14,
                  border: "0.5px solid #93C5FD",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: "var(--blue)",
                    marginBottom: 8,
                  }}
                >
                  💳 Split Payment
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: 8,
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "var(--radius-md)",
                      padding: 10,
                      border: "0.5px solid var(--border-light)",
                    }}
                  >
                    <div
                      style={{ fontSize: 11, color: "var(--text-secondary)" }}
                    >
                      Total Due
                    </div>
                    <div
                      style={{
                        fontSize: 16,
                        fontWeight: 800,
                        color: "var(--text-primary)",
                      }}
                    >
                      ₹9,660
                    </div>
                  </div>
                  <div
                    style={{
                      background: "var(--amber-light)",
                      borderRadius: "var(--radius-md)",
                      padding: 10,
                      border: "0.5px solid #EF9F27",
                    }}
                  >
                    <div style={{ fontSize: 11, color: "var(--amber)" }}>
                      Your Coins
                    </div>
                    <div
                      style={{
                        fontSize: 16,
                        fontWeight: 800,
                        color: "var(--amber)",
                      }}
                    >
                      ₹850
                    </div>
                  </div>
                  <div
                    style={{
                      background: "var(--red-light)",
                      borderRadius: "var(--radius-md)",
                      padding: 10,
                      border: "0.5px solid #F09595",
                    }}
                  >
                    <div style={{ fontSize: 11, color: "var(--red)" }}>
                      Pay via Gateway
                    </div>
                    <div
                      style={{
                        fontSize: 16,
                        fontWeight: 800,
                        color: "var(--red)",
                      }}
                    >
                      ₹8,810
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group mb12">
                <label>Payment For</label>
                <select id="tn-pay-for">
                  <option>April 2025 Rent — ₹9,660</option>
                  <option>May 2025 Rent — ₹9,660</option>
                  <option>Security Deposit</option>
                  <option>Other / Custom Amount</option>
                </select>
              </div>
              <div className="form-group mb12">
                <label>Remark</label>
                <input
                  type="text"
                  id="tn-remark"
                  placeholder="e.g. April rent payment"
                />
              </div>
              <div
                style={{
                  background: "var(--bg-secondary)",
                  borderRadius: "var(--radius-md)",
                  padding: "10px 12px",
                  marginBottom: 14,
                  fontSize: 12,
                  color: "var(--text-secondary)",
                }}
              >
                🪙 <strong>850 coins</strong> will be deducted from your wallet.
                The remaining <strong>₹8,810</strong> will be charged via the
                payment gateway.
              </div>
              <button
                className="btn btn-primary"
                style={{
                  width: "100%",
                  padding: 11,
                  fontSize: 14,
                  fontWeight: 700,
                }}
                onclick="redirectToPG(8810)"
              >
                💳 Make Payment — ₹8,810 via Gateway
              </button>
            </div>
            <div className="card">
              <div className="card-title">My Recent Requests</div>
              <div
                style={{
                  padding: 12,
                  background: "var(--bg-secondary)",
                  borderRadius: "var(--radius-md)",
                  marginBottom: 10,
                  border: "0.5px solid var(--border-light)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: 6,
                  }}
                >
                  <div style={{ fontSize: 13, fontWeight: 600 }}>
                    ₹9,660 — Rent
                  </div>
                  <span className="badge badge-pending">Pending</span>
                </div>
                <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                  UPI · Apr 17, 2025
                </div>
                <div
                  style={{
                    fontSize: 11,
                    fontFamily: "monospace",
                    color: "var(--text-tertiary)",
                  }}
                >
                  UTR: UTR123456789
                </div>
                <div
                  style={{ fontSize: 10, color: "var(--amber)", marginTop: 4 }}
                >
                  ⏳ Awaiting owner approval
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
